module.exports = __webpack_public_path__ + "static/NotoSansKR-Regular-839a2f6c607e26dee10678a077729ba5.otf";